import styled from 'styled-components';
import AppCSS from '../../../../utils/styled';

export const Components = {
  Container: styled.div`
    background-color: ${AppCSS.colors.white};
    width: 100%;
    min-height: 50px;
    border-radius: 10px;
    padding: 8px;
  `,

  Title: styled.div`
    ${AppCSS.fonts.h4};
    color: ${AppCSS.colors.black};
    margin-bottom: 8px;
  `,

  Field: styled.div`
    ${AppCSS.fonts.label14Medium};
    color: ${AppCSS.colors.black};
    margin-top: 4px;
  `,

  Key: styled.div`
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.blues.dark};
  `,

  Header: styled.div`
    display: flex;
    justify-content: space-between;
  `,
};
